export enum AtividadeStatusOrigemEnum {
    GetStatusDemanda = 'GetAtividadeEventos',
    GetStatusDemandaParcela = 'GetAtividadeEventosUnificada'
  }